import { useQuery, useUpdateQuery } from "hooks/useQuery";
import { useHistory, useRouteMatch } from "react-router-dom";
import Placeholder from "static/images/Imageplaceholder.svg";

import ToolTip from "components/design/toolTip";

const DynamicBackground = ({
  icon,
  color,
}: {
  icon: string;
  color: string;
}) => {
  return (
    <div
      style={{
        backgroundImage: `url(${icon})`,
        backgroundColor: color,
      }}
      className="t-h-[7.50rem] t-w-full t-bg-no-repeat t-bg-center t-bg-contain t-p-5 t-rounded-t-md t-bg-origin-content"
    ></div>
  );
};

const Tags = ({ tags }: { tags?: string[] }) => {
  if (!tags) return null;
  const tagString = `${tags.slice(1, -1).join(", ")} and ${tags.at(-1)}`;
  const tagAnd = tags?.slice(1).join(" and ");
  return (
    <div className="t-flex t-gap-1 t-text-neutral-70 t-text-body-sm">
      <div className="t-w-fit t-py-0.5 t-px-1.5 t-bg-neutral-0 t-rounded-2xl ">
        {tags?.at(0)}
      </div>
      {tags?.length > 1 && (
        <ToolTip side="right" text={tags?.length > 2 ? tagString : tagAnd}>
          <div className="t-w-fit t-py-0.5 t-px-1.5 t-bg-neutral-0 t-rounded-2xl">
            + {tags.length - 1}
          </div>
        </ToolTip>
      )}
    </div>
  );
};

export const PerkNewCards = ({ perk }: { perk: any }) => {
  const { name = "Company Name", icon = null, description, tags } = perk;

  const { url } = useRouteMatch();
  const queryParam = useQuery();
  const history = useHistory();

  const openPerksModal = (id: string) => {
    history.push(`${url}/${id}?${queryParam.toString()}`);
  };

  const perkString = tags.map(
    (tag: { title?: string; uuid?: string }) => tag?.title
  );

  return (
    <section
      onClick={() => openPerksModal(perk.slug)}
      className="t-flex t-flex-col t-gap-2 t-shadow-xs t-border-[1px] t-border-solid t-border-neutral-0 t-rounded-lg t-max-w-[16.875rem] t-h-[15.625rem] t-p-1 t-pb-3 hover:t-shadow-box-shadow t-overflow-y-hidden t-cursor-pointer t-w-[30%] sm:t-w-full sm:t-max-w-none"
    >
      {icon ? (
        <DynamicBackground icon={icon} color={perk.icon_bg_color} />
      ) : (
        <img
          src={Placeholder}
          alt={name}
          className="t-h-[6.9rem] t-w-full t-object-contain  t-rounded t-bg-neutral-0"
        />
      )}
      <div className="t-flex t-flex-col t-gap-2.5 t-px-1.5 t-pt-1">
        {perkString?.length > 0 && (
          <div className="t-text-subtext-sm t-text-text-30 t-truncate t-text-ellipsis">
            <Tags tags={perkString} />
          </div>
        )}
        <div className="t-flex t-flex-col t-gap-0.5">
          <div className="t-text-subtext t-text-text-100 t-h-[1.4rem] t-truncate ">
            {name}
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: description || "",
            }}
            className="t-text-body-sm t-font-light t-text-text-30 t-h-14 t-line-clamp-3"
          ></div>
        </div>
      </div>
    </section>
  );
};
